import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { Room } from '../../../../../models/hotel-room-types';
import { getVerbalPeople, getVerbalPlacements } from '../../../../../utils/format';

export interface RoomInfoProps {
    room: Room;
}
interface StyledRoomInfoProps
    extends RoomInfoProps,
        JSSClassesProps<ComponentJSSClasses> {}

export const RoomInfo = ({
    room,
    classes,
}: StyledRoomInfoProps) => {

    function renderRoomAccommodation(maxPerson: number) {
        if (maxPerson <= 0) return;

        return (
            <>
              &nbsp;&middot;&nbsp; Максимум {maxPerson}{' '}
                {getVerbalPeople(maxPerson)}
            </>
        );
    }

    function renderRoomSize(room: Room) {
        let roomText = '';
        if (room.isRangeArea) {
            if (!room.minArea || !room.maxArea) return;

            roomText = `${room.minArea}-${room.maxArea}`;
        } else {
            if ((room.area ?? 0) <= 0) return;

            roomText = (room.area ?? 0).toString();
        }
        return (
            <>
                {roomText} м<sup>2</sup>
            </>
        );
    }

    function renderRoomCount(roomCount: number) {
        if (roomCount <= 0) return;

        return (
            <>
              &nbsp;&middot;&nbsp;{roomCount} {getVerbalPlacements(roomCount)}
            </>
        );
    }

    return (
        <div className={classes.infoColumn}>
            <h3 className={classes.roomName}>{room.name}</h3>
            <p className={classes.roomParams}>
                {renderRoomSize(room)}
                {renderRoomCount(room.roomCount ?? 0)}
                {renderRoomAccommodation(room.maxPersonCount ?? 0)}
            </p>
            <p className={classes.roomDescription}>
                {room.description}
            </p>
        </div>
    );
};
